<ng-template #dlTooltipContent>
  <div (mouseenter)="cancelDlPopoverClose()" (mouseleave)="scheduleCloseDlPopoverFromContent()">
    Addresses in a distribution list cannot be edited at the item level. To make changes, update the address or distribution list via the <a routerLink="/account/addresses">Address Book</a>.
  </div>
</ng-template>

<ng-container *ngIf="!wslrEntity && !isDecisionPoint; else shipmentLabel">
  <ng-container *ngIf="isDistributionListAddress; else addressDropdown">
    <div class="dl-address-display" *ngIf="delivery.addressDefined">
      <div class="dl-address-display__content">
        <span class="font-weight-bold font-5">{{ addressLabel }}</span>
        <span class="font-6">{{ delivery.street_1 }}, {{ delivery.getCSZ() }}</span>
      </div>
      <i
        #dlPopover="ngbPopover"
        class="far fa-info-circle dl-address-info-icon"
        [ngbPopover]="dlTooltipContent"
        placement="bottom-start"
        container="body"
        popoverClass="dl-address-popover"
        triggers="manual"
        (mouseenter)="openDlPopover(dlPopover)"
        (mouseleave)="scheduleDlPopoverClose(dlPopover)"
      ></i>
    </div>
  </ng-container>
  <ng-template #addressDropdown>
  <ng-select
    #select
    class="ng-select--custom searchable address--selector ng-select--width-constrained"
    [ngClass]="dropDownClasses"
    [items]="computedAddressList"
    bindValue="uniqueAddressId"
    placeholder="Select address"
    [searchable]="true"
    [loading]="addressesLoading"
    [typeahead]="addressesSubject"
    (change)="onSelect($event)"
    [clearable]="false"
    (close)="onCloseDropdown()"
    [disabled]="disableDropdown"
    dropdownPosition="bottom"
    [(ngModel)]="addr_id"
    notFoundText="No address found"
  >
    <ng-template ng-label-tmp let-item="item">
      <ng-container *ngIf="delivery.addressDefined">
        <span class="d-block font-weight-bold font-5">{{ addressLabel }}</span>
        <span>{{ delivery.street_1 }}, {{ delivery.getCSZ() }}</span>
      </ng-container>
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
      <div
        class="address-list-title font-weight-bold text-underline color-black font-6"
      >
        <ng-container
          *ngIf="
            item.isFirstItem && item.address_type === addressType.Corporate
          "
        >
          Corporate
        </ng-container>
        <ng-container
          *ngIf="item.isFirstItem && item.address_type === addressType.Personal"
          >Personal</ng-container
        >
        <ng-container
          *ngIf="item.isFirstItem && item.address_type === addressType.Warehouse"
        >Warehouse</ng-container>
      </div>
      <span class="font-weight-bold font-6">
        <ng-container *ngIf="item.is_default">
          <i class="fas fa-star color-gold"></i>&nbsp;
        </ng-container>
        <ng-container *ngIf="item.isFavorite">
          <i class="fas fa-heart"></i>&nbsp;
        </ng-container>
        {{ item.label }}</span
      ><br />
      <span class="font-6">{{ item.longAddress }}</span>
    </ng-template>
    <ng-template ng-footer-tmp>
      <a
        *ngIf="canAddAddresses"
        href="#"
        class="d-block text-align-center my-2 link font-5 link-underline"
        (click)="addAddress()"
        >Add New Address&nbsp;<i class="fas fa-plus"></i
      ></a>
    </ng-template>
  </ng-select>
  </ng-template>
</ng-container>

<ng-template #shipmentLabel>
  <app-shipping-label
    [delivery]="delivery"
    [isDecisionPoint]="isDecisionPoint"
    [wslrEntity]="_entity"
    [attention]="attention"
  ></app-shipping-label>
</ng-template>
